import { render, staticRenderFns } from "./imprimir-pauta_2020-anual.vue?vue&type=template&id=6024676a&"
import script from "./imprimir-pauta_2020-anual.vue?vue&type=script&lang=js&"
export * from "./imprimir-pauta_2020-anual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports